import { Component, inject, input } from '@angular/core';
import { AlertService } from 'src/app/alerts/alerts.service';
import { FeesDetailComponent } from 'src/app/pages/checkout/fees-detail/fees-detail.component';
import { GoogleTagManagerService } from 'src/app/services/google-tag-manager.service';
import { GTMAreaEnum, GTMEnvironmentFlow } from 'src/app/services/models/google-tag-manager.model';

type Caller = 'modal' | 'checkout';

@Component({
  selector: 'app-fee-details-button',
  template: `
    <button class="fee-detail" (click)="openFeeDetail()">
      <p>Custo de parcelamento</p>
    </button>
  `,
  styles: `
    .fee-detail {
      background: none;
      border: none;
      padding: 0;
      margin: 0;
      display: flex;
      color: #425ccb;
      gap: 8px;
      align-items: center;
      p {
        font-weight: 500;
        font-size: 0.875rem;
        margin-bottom: 3px;
      }
    }
  `,
})
export class FeesDetailsButtonComponent {
  private alertService = inject(AlertService);
  private readonly googleTagManagerService = inject(GoogleTagManagerService);
  readonly caller = input<Caller>();

  openFeeDetail() {
    this.eventDecider();
    this.alertService.generic({ component: FeesDetailComponent });
  }

  eventDecider() {
    if (this.caller() === 'checkout') {
      this.googleTagManagerService.pushSelectContentEvent({
        item_id: 'flexpag-web_web_botao_meio_13',
        content_type: 'botao',
        item_text: 'custo-de-parcelamento',
        area: GTMAreaEnum.CHECKOUT,
        ambiente: GTMEnvironmentFlow.LOGGED,
      });
    } else {
      this.googleTagManagerService.pushSelectContentEvent({
        item_id: 'flexpag-web_web_botao_meio_12',
        content_type: 'botao-custo-de-parcelamento',
        item_text: 'modal-selecao-de-parcelas',
        area: GTMAreaEnum.CHECKOUT,
        ambiente: GTMEnvironmentFlow.LOGGED,
      });
    }
  }
}
